// extracted by mini-css-extract-plugin
module.exports = {"footerImg":"navbar_footerImg__7ayHw"};